import { render, staticRenderFns } from "./MainBookCard3ByTypes.vue?vue&type=template&id=2ea14c68"
import script from "./MainBookCard3ByTypes.vue?vue&type=script&lang=js"
export * from "./MainBookCard3ByTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports